export default __webpack_public_path__ + "fonts/inter-latin-600-normal.cf69c3beb14c128add3f.woff";